import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { refreshAccessToken } from "@/api/client";
import { RedirectIfAuthed, RequireAuth } from "@/components/common/RequireAuth";
import { useSession } from "@/store/session";
import { About } from "@/pages/About";
import { Admin } from "@/pages/Admin";
import { Chat } from "@/pages/Chat";
import { ChatGuest } from "@/pages/ChatGuest";
import { Landing } from "@/pages/Landing";
import { Login } from "@/pages/Login";
import { NotFound } from "@/pages/NotFound";
import { Register } from "@/pages/Register";

export function App() {
  const hasHydrated = useSession((s) => s.hasHydrated);

  // On (re)visit, once the persisted session has hydrated, silently slide the
  // session: as long as the refresh token is still valid, exchange it for a
  // fresh 30-day access + refresh token. A returning user only logs in again
  // after being away longer than the refresh-token lifetime.
  useEffect(() => {
    if (hasHydrated && useSession.getState().needsRefresh()) {
      void refreshAccessToken();
    }
  }, [hasHydrated]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route
          path="/login"
          element={
            <RedirectIfAuthed>
              <Login />
            </RedirectIfAuthed>
          }
        />
        <Route
          path="/register"
          element={
            <RedirectIfAuthed>
              <Register />
            </RedirectIfAuthed>
          }
        />
        <Route
          path="/chat"
          element={
            <RequireAuth>
              <Chat />
            </RequireAuth>
          }
        />
        <Route
          path="/chat/guest"
          element={<ChatGuest />}
        />
        <Route
          path="/chat/:conversationId"
          element={
            <RequireAuth>
              <Chat />
            </RequireAuth>
          }
        />
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <Admin />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
